<template>
	<el-dialog :title="$t('enquiryTitle')" :visible.sync="localVisible" width="1000px" top="5vh" center
		class="enquiry-dialog" :before-close="handleClose" :close-on-click-modal="false">
		<div class="enquiry-tip">{{$t('enquiryTipTitle')}}</div>
		<div class="enquiry-tip">{{$t('enquiryTipContent')}}</div>
		<div class="enquiry-alert">{{$t('enquiryTipAlert')}}</div>
		<el-form :model="enquiryForm" :rules="enquiryRules" ref="enquiryForm" label-width="140px" class="enquiry-form"
			label-position="top">
			<el-row>
				<el-col :span="7">
					<el-form-item :label="$t('purchaseType')" prop="categoryId">
						<el-select v-model="enquiryForm.categoryId" :placeholder="$t('selectPlaceholder')"
							class="form-select">
							<el-option :label="category.name" :value="category.id"
								v-for="(category,index) in categories" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="17">
					<el-form-item :label="$t('contactEmail')" prop="email">
						<el-input v-model="enquiryForm.email" :placeholder="$t('emailPlaceholder')" disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="7">
					<el-form-item :label="$t('urgencyLevel')" prop="urgency">
						<el-select v-model="enquiryForm.urgency" :placeholder="$t('selectPlaceholder')"
							class="form-select">
							<el-option :label="$t('veryUrgent')" value="very_urgent"></el-option>
							<el-option :label="$t('urgent')" value="urgent"></el-option>
							<el-option :label="$t('normal')" value="normal"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item :label="$t('purchaseQuantity')" prop="quantity">
						<el-input-number controls-position="right" v-model="enquiryForm.quantity"
							:placeholder="$t('quantityPlaceholder')" style="width: 95%;"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<div style="display: flex;align-items: flex-end;">
						<el-form-item :label="$t('priceRange')" prop="priceMin">
							<el-input-number controls-position="right" v-model="enquiryForm.priceMin"
								style="width: 95%;" :placeholder="$t('priceRangePlaceholder')"></el-input-number>
						</el-form-item>
						<el-form-item label=" ">
							<div style="width: 10px;margin-right: 5px;">~</div>
						</el-form-item>
						<el-form-item label=" " prop="priceMax">
							<el-input-number controls-position="right" v-model="enquiryForm.priceMax"
								style="width: 95%;" :placeholder="$t('priceRangePlaceholder')"></el-input-number>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item :label="$t('productDescription')" prop="description">
						<el-input type="textarea" v-model="enquiryForm.description" :rows="4"
							:placeholder="$t('descriptionPlaceholder')" maxlength="500" show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item :label="$t('referenceImages')" prop="imageUrl">
						<el-upload :action="uploadUrl" ref="upload" :auto-upload="false" list-type="picture-card"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess"
							:on-error="handleError" multiple :headers="headers">
							<i class="el-icon-camera"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible" append-to-body top="5vh">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="submitEnquiry" :loading="isSubmit">{{ $t('confirm') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import API_DOMAINS from '@/api/core/config'
	import storage from "@/utils/storage.js";
	import productApi from '@/api/product';
	import wantedApi from '@/api/wanted'
	export default {
		name: 'EnquiryDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				localVisible: this.visible,
				enquiryForm: {
					categoryId: '', //商品分类id
					description: '',
					urgency: '', //紧急程度
					quantity: undefined, //期望数量
					priceMin: undefined, //最低价格
					priceMax: undefined, //最高价格
					description: '', //求购描述
					images: [], //求购图片URL数组
					imageUrl: ''
				},
				categories: [],
				dialogImageUrl: '',
				dialogVisible: false,
				uploadedCount: 0, // 已上传成功的图片数量
				totalFilesToUpload: 0, // 需要上传的图片总数
				uploadUrl: API_DOMAINS.uploadUrl,
				headers: {
					"accessToken": storage.getToken()
				},
				isSubmit: false,
			}
		},
		watch: {
			visible(val) {
				this.localVisible = val;
				if (val) {
					this.$nextTick(() => {
						this.$refs.enquiryForm && this.$refs.enquiryForm.resetFields();
						this.getGoodsCategory();
						this.getUserInfo();
					})
				}
			},
			localVisible(val) {
				this.$emit('update:visible', val);
			}
		},
		computed: {
			enquiryRules() {
				return {
					categoryId: [{
						required: true,
						message: this.$t('purchaseTypeRequired'),
						trigger: 'change'
					}],
					email: [{
							required: false,
							message: this.$t('emailRequired'),
							trigger: 'blur'
						},
						{
							type: 'email',
							message: this.$t('emailInvalid'),
							trigger: 'blur'
						}
					],
					urgency: [{
						required: true,
						message: this.$t('urgencyLevelRequired'),
						trigger: 'change'
					}],
					quantity: [{
							type: 'number',
							min: 1,
							max: 9999,
							message: this.$t('quantityRangeError'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (Number.isInteger(value)) {
									callback();
								} else if (value == undefined || value == null || value == '') {
									callback()
								} else {
									callback(new Error(this.$t('integerError')));
								}
							},
							trigger: 'blur'
						}
					],
					priceMin: [{
							type: 'number',
							min: 1,
							max: 99999.99,
							message: this.$t('priceRangeError'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (value == undefined || value == null || value == '') {
									callback();
								} else if (isNaN(Number(value))) {
									callback(new Error(this.$t('priceRangeError')))
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					priceMax: [{
							type: 'number',
							min: 1,
							max: 99999.99,
							message: this.$t('priceRangeError'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (value == undefined || value == null || value == '') {
									callback();
								} else if (isNaN(Number(value))) {
									callback(new Error(this.$t('priceRangeError')))
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					description: [{
							required: true,
							message: this.$t('descriptionPlaceholder'),
							trigger: 'blur'
						},
						{
							min: 20,
							message: this.$t('descriptionLengthError'),
							trigger: 'blur'
						}
					],
					imageUrl: [{
						required: true,
						message: this.$t('imagesRequired'),
						trigger: 'blur'
					}]
				};
			}
		},
		methods: {
			//获取商品分类
			async getGoodsCategory() {
				const res = await productApi.getGoodsCategory(0);
				this.categories = res.result;
			},
			//获取登录用户信息
			getUserInfo() {
				var userInfo = JSON.parse(storage.getUserInfo());
				this.enquiryForm.email = userInfo.email;
			},
			handleClose() {
				this.$confirm(this.$t('closeEnquire'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.localVisible = false;
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			submitEnquiry() {
				//检查是否有选择图片，如果有设置imageUrl不为空，避开必填项检测
				if (this.$refs.upload && this.$refs.upload.uploadFiles.length > 0) {
					this.enquiryForm.imageUrl = "sourcefind";
				}
				//判断价格区间是否有误
				if (this.enquiryForm.priceMin && this.enquiryForm.priceMax) {
					if (this.enquiryForm.priceMin > this.enquiryForm.priceMax) {
						return this.$message.warning(this.$t('priceRangeInputError'))
					}
				}
				this.$refs.enquiryForm.validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						// 检查是否有选择的图片需要上传
						if (this.$refs.upload && this.$refs.upload.uploadFiles.length > 0) {
							// 初始化上传计数
							this.uploadedCount = 0;
							this.totalFilesToUpload = this.$refs.upload.uploadFiles.length;
							// 清空之前的图片数组
							this.enquiryForm.images = [];
							// 开始上传图片
							this.$refs.upload.submit();
						} else {
							// 没有图片需要上传，直接执行保存操作
							this.saveEnquiry();
						}
					}
				})
			},
			// 保存询价操作
			async saveEnquiry() {
				const res = await wantedApi.publish(this.enquiryForm);
				if (res.code == 200) {
					this.$message.success(this.$t('enquirySubmitted'));
					// 清除上传的图片信息
					if (this.$refs.upload) {
						// 清除上传文件列表
						this.$refs.upload.clearFiles();
						// 重置上传计数
						this.uploadedCount = 0;
						this.totalFilesToUpload = 0;
					}
					// 清除表单中的图片数组
					this.enquiryForm.images = [];
					this.localVisible = false;
					this.$emit('save-callback', true)
				} else {
					this.$message.success(this.$t('enquiryFailed'));
				}
				this.isSubmit = false;
			},
			resetForm() {
				this.enquiryForm = {
					purchaseType: '',
					email: '',
					urgencyLevel: '',
					quantity: '',
					priceRange: '',
					description: '',
					imageUrl: ''
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			// 上传成功回调
			handleSuccess(response, file, fileList) {
				// 将图片URL添加到表单中
				this.enquiryForm.images.push(response.result);
				// 增加已上传计数
				this.uploadedCount++;
				// 判断是否所有图片都已上传完成
				if (this.uploadedCount === this.totalFilesToUpload) {
					// 所有图片上传完成，执行保存询价操作
					this.saveEnquiry();
				}
			},
			// 上传失败回调
			handleError(err, file, fileList) {
				this.$message.error(this.$t('imageUploadFailed'));
				// 上传失败，重置上传计数，避免后续操作
				this.uploadedCount = 0;
				this.totalFilesToUpload = 0;
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			}
		}
	}
</script>

<style scoped>
	.enquiry-tip {
		color: #666;
		font-size: 12px;
	}

	.enquiry-alert {
		color: #D9001B;
		font-size: 12px;
	}

	.enquiry-dialog {
		border-radius: 8px;
	}

	.enquiry-dialog .el-dialog {
		border-radius: 8px;
	}

	.enquiry-dialog .el-dialog__header {
		border-bottom: 1px solid #eee;
		padding-bottom: 15px;
	}

	.enquiry-dialog .el-dialog__title {
		font-weight: 600;
	}

	.enquiry-form {
		padding: 10px 20px;
	}

	.enquiry-form .el-form-item {
		margin-bottom: 20px;
	}

	.enquiry-form .el-form-item__label {
		font-weight: 500;
		color: #333;
	}

	.form-select {
		width: 95%;
	}

	.enquiry-form .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.enquiry-form .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.enquiry-form .el-input__inner:focus {
		border-color: #0171F9;
	}

	.enquiry-form .el-textarea__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.enquiry-form .el-textarea__inner:hover {
		border-color: #c0c4cc;
	}

	.enquiry-form .el-textarea__inner:focus {
		border-color: #0171F9;
	}

	.enquiry-form .el-select .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.enquiry-form .el-select .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.enquiry-form .el-select .el-input__inner:focus {
		border-color: #0171F9;
	}

	.enquiry-form .el-input-number {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.enquiry-form .el-input-number:hover {
		border-color: #c0c4cc;
	}

	.enquiry-form .el-input-number:focus-within {
		border-color: #016AF8;
	}

	.enquiry-form .el-input-number .el-input__inner {
		border: none;
	}

	.dialog-footer {
		display: flex;
		justify-content: right;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #016AF8;
		border-color: #016AF8;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	:deep .el-input__inner {
		color: #000 !important;
		border: 1px solid #DCDFE6 !important;
		text-align: left !important;
	}

	:deep .el-form-item__label {
		margin-bottom: -18px;
	}
</style>